export default __webpack_public_path__ + "static/media/c2bdb42b-62fd-43dd-912b-19a0a514170d.a4f830a8.JPG";